function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "chart-line-data",
  d: "M13.277,23.974a5.814,5.814,0,0,0,1.285.164,5.471,5.471,0,0,0,3.05-.93l4.407,3.926a5.308,5.308,0,0,0-.274,4.336,5.472,5.472,0,1,0,8.714-5.965l3.474-6.963a5.171,5.171,0,0,0,3.981-.725A5.472,5.472,0,1,0,31.5,17.3l-3.474,6.963a5.281,5.281,0,0,0-1.15-.124,5.471,5.471,0,0,0-3.05.93l-4.407-3.926a5.308,5.308,0,0,0,.274-4.336,5.472,5.472,0,1,0-8.823,5.869L4.986,33.715V2.25H2.25V37.819a2.736,2.736,0,0,0,2.736,2.736H40.555V37.819H5.9ZM35.083,10.458a2.736,2.736,0,1,1-2.736,2.736A2.736,2.736,0,0,1,35.083,10.458ZM29.61,29.61a2.736,2.736,0,1,1-2.736-2.736A2.736,2.736,0,0,1,29.61,29.61ZM14.562,15.93a2.736,2.736,0,1,1-2.736,2.736A2.736,2.736,0,0,1,14.562,15.93Z",
  transform: "translate(-2.25 -2.25)",
  fill: "#ac1ede"
});

var SvgChartLineData = function SvgChartLineData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.305,
    height: 38.305,
    viewBox: "0 0 38.305 38.305",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartLineData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-line-data.86e19f26.svg";
export { ForwardRef as ReactComponent };